
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("lR98f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3d69439fa9d26ebc$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $fxMO5 = parcelRequire("fxMO5");

var $jcRK7 = parcelRequire("jcRK7");

var $1biTA = parcelRequire("1biTA");

var $iYz1m = parcelRequire("iYz1m");

var $ik9zp = parcelRequire("ik9zp");

var $ay2XP = parcelRequire("ay2XP");

var $aI0YR = parcelRequire("aI0YR");

var $5LmQo = parcelRequire("5LmQo");

var $3vmXg = parcelRequire("3vmXg");
const $3d69439fa9d26ebc$var$toNumber = (idFromPath)=>{
    return idFromPath ? Number(idFromPath) : undefined;
};
class $3d69439fa9d26ebc$var$RequestCreatePage extends $bSJIT.Component {
    /**
   * Returns true when UI modifications should be fetched.
   */ canFetchUiModifications(portalId, requestTypeId) {
        return !!requestTypeId && !!portalId;
    }
    componentDidMount() {
        const { requestTypeId: requestTypeId, portalId: portalId } = this.props.match.params;
        this.props.fetchRequestCreate({
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            portalId: $3d69439fa9d26ebc$var$toNumber(portalId),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            id: $3d69439fa9d26ebc$var$toNumber(requestTypeId)
        });
        if (this.canFetchUiModifications(portalId, requestTypeId)) this.props.fetchUiModifications({
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            portalId: $3d69439fa9d26ebc$var$toNumber(portalId),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            requestTypeId: $3d69439fa9d26ebc$var$toNumber(requestTypeId)
        });
    }
    componentDidUpdate(prevProps) {
        const { fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications } = this.props;
        const { portalId: portalId, requestTypeId: requestTypeId } = this.props.match.params;
        const { requestTypeId: prevRequestId } = prevProps.match.params;
        const requestChanged = requestTypeId && requestTypeId !== prevRequestId;
        if (requestChanged) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            fetchRequestCreate({
                portalId: $3d69439fa9d26ebc$var$toNumber(portalId),
                id: $3d69439fa9d26ebc$var$toNumber(requestTypeId)
            });
            if (this.canFetchUiModifications(portalId, requestTypeId)) fetchUiModifications({
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                portalId: $3d69439fa9d26ebc$var$toNumber(portalId),
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                requestTypeId: $3d69439fa9d26ebc$var$toNumber(requestTypeId)
            });
        }
    }
    render() {
        const { sideBarOpen: sideBarOpen } = this.state;
        const { isLoading: isLoading, error: error, announcement: announcement, requestTypeName: requestTypeName, portalName: portalName, isProjectSimplified: isProjectSimplified, isProjectAdmin: isProjectAdmin, projectId: projectId } = this.props;
        const { requestTypeId: requestTypeId, portalId: portalId } = this.props.match.params;
        return /*#__PURE__*/ $bSJIT.createElement((0, $3vmXg.default), {
            requestTypeName: requestTypeName,
            projectId: projectId,
            portalName: portalName,
            loading: isLoading,
            announcement: announcement,
            requestTypeId: Number(requestTypeId),
            portalId: Number(portalId),
            sideBarOpen: sideBarOpen,
            toggleSidebar: this.toggleSideBar,
            isProjectSimplified: isProjectSimplified,
            isProjectAdmin: isProjectAdmin,
            ...error
        });
    }
    constructor(...args){
        super(...args), this.state = {
            sideBarOpen: !!$5LmQo.get('customize')
        }, this.toggleSideBar = (value)=>{
            this.setState({
                sideBarOpen: value !== undefined ? value : !this.state.sideBarOpen
            });
        };
    }
}
const $3d69439fa9d26ebc$var$selector = (0, $BOq7h.createSelector)((state, props)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ay2XP.getRequestCreateOrError)(state, props.match.params.portalId, props.match.params.requestTypeId), (state, props)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ik9zp.getPortalAnnouncement)(state, $3d69439fa9d26ebc$var$toNumber(props.match.params.portalId)), (state, props)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ik9zp.getProjectId)(state, $3d69439fa9d26ebc$var$toNumber(props.match.params.portalId)), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $ik9zp.getName)(state, $3d69439fa9d26ebc$var$toNumber(props.match.params.portalId)), (state, props)=>(0, $ay2XP.getFormName)(state, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $3d69439fa9d26ebc$var$toNumber(props.match.params.portalId), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $3d69439fa9d26ebc$var$toNumber(props.match.params.requestTypeId)), (state, props)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ik9zp.getIsProjectSimplified)(state, $3d69439fa9d26ebc$var$toNumber(props.match.params.portalId)), (state, props)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ik9zp.getCanAdministerProject)(state, $3d69439fa9d26ebc$var$toNumber(props.match.params.portalId)), (state)=>(0, $aI0YR.getCanAdministerJIRA)(state), (state)=>(0, $aI0YR.isLoggedIn)(state), (request, announcement, projectId, portalName, requestTypeName, isProjectSimplified, isProjectAdmin, isJiraAdmin, isLoggedIn)=>({
        announcement: announcement,
        projectId: projectId,
        portalName: portalName,
        requestTypeName: requestTypeName,
        isProjectSimplified: isProjectSimplified,
        isProjectAdmin: isProjectAdmin,
        isJiraAdmin: isJiraAdmin,
        isLoggedIn: isLoggedIn,
        error: request && 'error' in request ? request : undefined,
        isLoading: !request
    }));
var $3d69439fa9d26ebc$export$2e2bcd8739ae039 = (0, $egQxE.connect)($3d69439fa9d26ebc$var$selector, {
    fetchRequestCreate: (0, $1biTA.fetchRequestCreateAction),
    fetchUiModifications: (0, $iYz1m.fetchUiModificationsAction)
})((0, $fxMO5.withExperience)((0, $jcRK7.ExperienceName).REQUEST_CREATE)($3d69439fa9d26ebc$var$RequestCreatePage));

});
parcelRegister("3vmXg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f52ee920bae16cb$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $cwcdv = parcelRequire("cwcdv");

var $kPxiY = parcelRequire("kPxiY");

var $2ERPT = parcelRequire("2ERPT");

var $fFr9c = parcelRequire("fFr9c");

var $lFpPv = parcelRequire("lFpPv");

var $i7phc = parcelRequire("i7phc");

var $fK3tS = parcelRequire("fK3tS");

var $cJJTb = parcelRequire("cJJTb");

var $hiiav = parcelRequire("hiiav");

var $fK5uK = parcelRequire("fK5uK");

var $aJYKE = parcelRequire("aJYKE");

var $hCHt7 = parcelRequire("hCHt7");

var $dlaM3 = parcelRequire("dlaM3");

var $cAJ8B = parcelRequire("cAJ8B");

var $cYNAS = parcelRequire("cYNAS");

var $eXUFK = parcelRequire("eXUFK");

var $lh0Vs = parcelRequire("lh0Vs");

var $jH4ij = parcelRequire("jH4ij");

var $2rxiA = parcelRequire("2rxiA");

var $aFEQi = parcelRequire("aFEQi");
parcelRequire("167dD");
var $3o9kd = parcelRequire("3o9kd");
const $0f52ee920bae16cb$export$cf665508b87b4a0f = ({ loading: loading, requestTypeName: requestTypeName, portalName: portalName, intl: intl, announcement: announcement, portalId: portalId, projectId: projectId, requestTypeId: requestTypeId, isProjectSimplified: isProjectSimplified, isProjectAdmin: isProjectAdmin, sideBarOpen: sideBarOpen, toggleSidebar: toggleSidebar })=>{
    const openSidebar = $bSJIT.useCallback(()=>toggleSidebar(true), [
        toggleSidebar
    ]);
    const closeSidebar = $bSJIT.useCallback(()=>toggleSidebar(false), [
        toggleSidebar
    ]);
    const title = requestTypeName && portalName && intl.formatMessage((0, $lh0Vs.default).title, {
        requestTypeName: requestTypeName,
        portalName: portalName
    });
    return /*#__PURE__*/ $bSJIT.createElement((0, $2ERPT.default), {
        title: title,
        ignoreBaseTitle: true
    }, /*#__PURE__*/ $bSJIT.createElement((0, $fK5uK.LoadingContainer), {
        isLoading: loading
    }, !!announcement && !(0, $lFpPv.isUseHelpCenterRefresh)() && /*#__PURE__*/ $bSJIT.createElement((0, $cwcdv.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $jH4ij.AnnouncementInnerContainer)
    }), /*#__PURE__*/ $bSJIT.createElement((0, $cAJ8B.PaperContent), null, /*#__PURE__*/ $bSJIT.createElement((0, $2rxiA.UiModificationsEntryPoint), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ $bSJIT.createElement((0, $3o9kd.default), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ $bSJIT.createElement((0, $aJYKE.PortalIntlBoundary), null, /*#__PURE__*/ $bSJIT.createElement((0, $hiiav.HeaderConnectFragments), {
        page: (0, $kPxiY.REQUEST_CREATE),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ $bSJIT.createElement((0, $dlaM3.ForgeHeaderModule), {
        page: (0, $i7phc.FORGE_REQUEST_CREATE),
        portalId: portalId,
        projectId: projectId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ $bSJIT.createElement((0, $eXUFK.RequestCreateForm), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }))), /*#__PURE__*/ $bSJIT.createElement((0, $hiiav.FooterConnectFragments), {
        page: (0, $kPxiY.REQUEST_CREATE),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ $bSJIT.createElement((0, $cAJ8B.PaperContent), null, /*#__PURE__*/ $bSJIT.createElement((0, $hCHt7.ForgeFooterModule), {
        page: (0, $i7phc.FORGE_REQUEST_CREATE),
        portalId: portalId,
        projectId: projectId,
        requestTypeId: requestTypeId
    })), isProjectSimplified && isProjectAdmin && /*#__PURE__*/ $bSJIT.createElement((0, $cJJTb.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cYNAS.LazyPortalSettingsSidebar), {
        isProjectSimplified: isProjectSimplified,
        initialRoute: (0, $aFEQi.getPortalSettingsRequestTypeDetailOrphanRoute)(requestTypeId),
        isOpen: sideBarOpen,
        onOpen: openSidebar,
        onClose: closeSidebar
    }))));
};
var $0f52ee920bae16cb$export$2e2bcd8739ae039 = (0, $fFr9c.withErrorPage)((0, $fK3tS.default)($0f52ee920bae16cb$export$cf665508b87b4a0f));

});
parcelRegister("lh0Vs", function(module, exports) {
$parcel$export(module.exports, "default", () => $f664911628f5f0df$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $f664911628f5f0df$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    title: {
        defaultMessage: '{requestTypeName} - {portalName} - Jira Service Management',
        description: 'Page title for request create page',
        id: 'cv.jsm.request.create.page.title'
    }
});

});

parcelRegister("jH4ij", function(module, exports) {
$parcel$export(module.exports, "AnnouncementInnerContainer", () => $6a0b4b029a1a29ae$export$4c5bf61cbf064bd5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $cAJ8B = parcelRequire("cAJ8B");
const $6a0b4b029a1a29ae$export$4c5bf61cbf064bd5 = /*#__PURE__*/ (0, $4v2A7.default)((0, $cAJ8B.PaperContent)).withConfig({
    componentId: "sc-1kzo2sn-0"
})`padding-top:0;`;

});

parcelRegister("aFEQi", function(module, exports) {
$parcel$export(module.exports, "getPortalSettingsBaseRoute", () => $e823e5799baea9e0$export$11069e93a35fbfa0);
$parcel$export(module.exports, "getPortalSettingsRequestGroupDetailRoute", () => $e823e5799baea9e0$export$ea915b230bba0df3);
$parcel$export(module.exports, "getPortalSettingsRequestTypeDetailRoute", () => $e823e5799baea9e0$export$a284c244dca4da37);
$parcel$export(module.exports, "getPortalSettingsRequestTypeDetailOrphanRoute", () => $e823e5799baea9e0$export$62fa242341fb035b);
$parcel$export(module.exports, "getExperienceLocation", () => $e823e5799baea9e0$export$8d583d431dac521d);
$parcel$export(module.exports, "SidebarHeader", () => (parcelRequire("e5Pbz")).SidebarHeader);

var $eDcdn = parcelRequire("eDcdn");

var $e5Pbz = parcelRequire("e5Pbz");
const $e823e5799baea9e0$export$11069e93a35fbfa0 = ()=>`${(0, $eDcdn.getRelativeBasePath)()}/portal/customize/sidebar`;
const $e823e5799baea9e0$export$ea915b230bba0df3 = (requestGroupId)=>`${$e823e5799baea9e0$export$11069e93a35fbfa0()}/request-groups/${requestGroupId}`;
const $e823e5799baea9e0$export$a284c244dca4da37 = (requestGroupId, requestTypeId)=>`${$e823e5799baea9e0$export$11069e93a35fbfa0()}/request-groups/${requestGroupId}/request-types/${requestTypeId}`;
const $e823e5799baea9e0$export$62fa242341fb035b = (requestTypeId)=>`${$e823e5799baea9e0$export$11069e93a35fbfa0()}/request-types/${requestTypeId}`;
const $e823e5799baea9e0$export$8d583d431dac521d = (experience)=>{
    switch(experience){
        case 'add-announcement':
            return `${$e823e5799baea9e0$export$11069e93a35fbfa0()}/add-announcement`;
        case 'request-groups':
            return `${$e823e5799baea9e0$export$11069e93a35fbfa0()}/request-groups`;
        default:
            return undefined;
    }
};

});
parcelRegister("e5Pbz", function(module, exports) {
$parcel$export(module.exports, "SidebarHeader", () => $72236eea2e8b2132$export$e575a964a1fe8b0);
$parcel$export(module.exports, "EmptyStateMessage", () => $72236eea2e8b2132$export$11e5ba4f4669e663);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");
const $72236eea2e8b2132$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $4v2A7.default).h3.withConfig({
    componentId: "sc-1uybpck-0"
})`${$98sDU.h700};margin-top:${"var(--ds-space-200, 16px)"};margin-bottom:${"var(--ds-space-300, 24px)"};flex-shrink:0;`;
const $72236eea2e8b2132$export$11e5ba4f4669e663 = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-1uybpck-1"
})`font-size:${$98sDU.xsmall};color:${"var(--ds-text-subtle, #6B778C)"};padding-top:${"var(--ds-space-100, 8px)"};padding-bottom:${"var(--ds-space-100, 8px)"};width:60%;margin:auto;`;

});


parcelRegister("167dD", function(module, exports) {
$parcel$export(module.exports, "HeaderFocusMode", () => (parcelRequire("3o9kd")).default);

var $3o9kd = parcelRequire("3o9kd");

});
parcelRegister("3o9kd", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a6dc9753d8ff141$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $ay2XP = parcelRequire("ay2XP");

var $2PyTf = parcelRequire("2PyTf");
const $3a6dc9753d8ff141$var$getRequestTypeName = (state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    return portalId && requestTypeId ? (0, $ay2XP.getFormName)(state, portalId, requestTypeId) : undefined;
};
const $3a6dc9753d8ff141$var$getRequestTypeInstructions = (state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    return portalId && requestTypeId ? (0, $ay2XP.getFormInstructions)(state, portalId, requestTypeId) : undefined;
};
const $3a6dc9753d8ff141$var$getLogoUrl = (state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    return portalId && requestTypeId ? (0, $ay2XP.getIconUrl)(state, portalId, requestTypeId) : undefined;
};
const $3a6dc9753d8ff141$var$selector = (0, $BOq7h.createSelector)($3a6dc9753d8ff141$var$getRequestTypeName, $3a6dc9753d8ff141$var$getRequestTypeInstructions, $3a6dc9753d8ff141$var$getLogoUrl, (requestTypeName, requestTypeInstructions, logoUrl)=>({
        logoUrl: logoUrl,
        dataTestId: 'paper-header',
        subHeading: requestTypeName,
        description: requestTypeInstructions,
        dangerouslyAllowHtmlInDescription: true
    }));
var $3a6dc9753d8ff141$export$2e2bcd8739ae039 = (0, $egQxE.connect)($3a6dc9753d8ff141$var$selector)((0, $2PyTf.PaperHeader));

});





//# sourceMappingURL=request-create-form.93d1d9a2.js.map
